import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import logo from "@/assets/image/logo.png";
import PostSvg from "@/assets/svg/PostSvg";
import { MouseEvent, useState } from "react";
import UserInfo from "./component/UserInfo";
import SocialLinks from "./component/SocialLinks";
import SidebarMenu from "./component/SideBarMenu";
import { styles } from "./stylesSidebar";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "@/hooks/useAppDispatch";
import { useAppSelector } from "@/hooks/useAppSelector";
import { setCreatePostModalState } from "@/store/slice/modalSlice";
import Wallet from "./component/Wallet";
import CreateLongPostModal from "@/components/UI/modal/CreateLongPostModal/CreateLongPostModal";
import { ListItemIcon, ListItemText, Menu, MenuItem, Typography } from "@mui/material";
import CreatePostSvg from "@/assets/svg/CreatePostSvg";
import CreateLongPostSvg from "@/assets/svg/CreateLongPostSvg";
import { RequireAuth } from "@/components/RequireAuth";
import UnitedStatesSvg from "@/assets/svg/flags/united statesSvg";
import ArrowDawnSvg from "@/assets/svg/ArrowDawnSvg";
import MarketSelectionModal from "@/components/UI/modal/MarketSelection/MarketSelection";
import CustomToast from "@/components/UI/CustomToast/CustomToast";

export default function Sidebar() {
  const secondElementExists = false; //////// MarketSelection
  const [isLongPostModalOpen, setIsLongPostModalOpen] = useState(false);
  const [openMarketSelection, setOpenMarketSelection] = useState(false);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { user: authUser } = useAppSelector((state) => state.auth);
  const handleOpen = () => dispatch(setCreatePostModalState(true));

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const openMenu = Boolean(anchorEl);
  const handleClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  const [toast, setToast] = useState<{
    message: string;
    success?: boolean;
    link: { text: string; href: string };
  } | null>(null);

  return (
    <Box sx={styles.sidebarWrapper} className="hide-scrollbar">
      {toast && (
        <CustomToast
          message={toast.message}
          success={toast.success}
          link={toast.link}
          onClose={() => setToast(null)}
        />
      )}

      <MarketSelectionModal
        open={openMarketSelection}
        onClose={() => setOpenMarketSelection(false)}
      />
      <Box
        sx={{
          ...styles.Sidebarheader,
          justifyContent: secondElementExists ? "space-between" : "start",
        }}
      >
        <Box
          sx={styles.logoBox}
          onClick={() => {
            navigate("/", {
              state: { forceScrollTop: Date.now() },
            });
          }}
        >
          <img
            src={logo}
            alt="Wethemrkt Logo"
            width={112}
            height={32}
            style={{ objectFit: "contain" }}
          />
        </Box>

        {secondElementExists && (
          <Box sx={styles.MarketSelection} onClick={() => setOpenMarketSelection(true)}>
            <UnitedStatesSvg />
            <Box sx={{ width: "16px", marginTop: "4px" }}>
              <ArrowDawnSvg />
            </Box>
          </Box>
        )}
      </Box>
      <Box
        sx={{
          paddingLeft: "16px",
          paddingTop: "16px",
          paddingRight: "24px",
          paddingBottom: "10px",
        }}
      >
        <RequireAuth>
          <Wallet />
        </RequireAuth>
        <SidebarMenu />
        <RequireAuth>
          <Button
            onClick={handleClick}
            variant="contained"
            startIcon={<PostSvg />}
            sx={styles.buttonText}
          >
            Post
          </Button>
        </RequireAuth>

        <UserInfo />
        <SocialLinks withDivider={!!authUser} />

        {/* Menu */}
        <Menu
          id="post-menu"
          anchorEl={anchorEl}
          open={openMenu}
          onClose={handleCloseMenu}
          MenuListProps={{
            "aria-labelledby": "post-menu-button",
          }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          PaperProps={{
            sx: {
              marginTop: "-6rem",
              bgcolor: "#fff",
            },
          }}
        >
          <MenuItem
            key={"post"}
            onClick={() => {
              handleOpen();
              handleCloseMenu();
            }}
            sx={{ gap: "0.25rem" }}
          >
            <ListItemIcon sx={{ minWidth: "0px !important" }}>
              <CreatePostSvg />
            </ListItemIcon>
            <ListItemText>
              <Typography sx={{ padding: "0.5rem" }}>Post</Typography>
            </ListItemText>
          </MenuItem>

          <MenuItem
            key={"longPost"}
            onClick={() => {
              setIsLongPostModalOpen(true);
              handleCloseMenu();
            }}
            sx={{ gap: "0.25rem" }}
          >
            <ListItemIcon sx={{ minWidth: "0px !important" }}>
              <CreateLongPostSvg />
            </ListItemIcon>
            <ListItemText>
              <Typography sx={{ padding: "0.5rem" }}>Create Article</Typography>
            </ListItemText>
          </MenuItem>
        </Menu>
      </Box>
      <CreateLongPostModal
        open={isLongPostModalOpen}
        setOpen={setIsLongPostModalOpen}
        handleClose={() => setIsLongPostModalOpen(false)}
        setIsLongPostModalOpen={setIsLongPostModalOpen}
        setToast={setToast}
      />
    </Box>
  );
}
